import { render, staticRenderFns } from "./RoomPermissions.vue?vue&type=template&id=d54839c4&scoped=true"
import script from "./RoomPermissions.vue?vue&type=script&lang=ts"
export * from "./RoomPermissions.vue?vue&type=script&lang=ts"
import style0 from "./RoomPermissions.vue?vue&type=style&index=0&id=d54839c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.11.0_webpack@5.99.8__lodash@4.17.21_prettier@2.8.8_vue-_69bc0556815cefdff9c73fe5644cf446/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d54839c4",
  null
  
)

export default component.exports